import { InfoCircleOutlined, LeftOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useInfiniteMessages } from "../../../hooks/useMessages";
import { StyledChatView } from "./styles";
import TicketInfo from "./TicketInfo";
import { selectUser } from "../../../store/user/selectors";
import { useEffect, useMemo, useState } from "react";
import { Button, Empty, Spin } from "antd";
import Avatar from "../../../components/generic/Avatar";
import { getFullName } from "../../../utils/shared";
import ChatInput from "./ChatInput";
import MessageItem from "./MessageItem";
import { setKeyValue } from "../../../store/chats/slice";
import { getChatMembers } from "./helper";
import LogoImage from "../../../assets/images/logo.png";
const ChatView = () => {
  const [isShowTicketInfo, setIsShowTicketInfo] = useState(false);
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  const {
    isLoading,
    scrollContainerRef,
    observerTarget,
    selectedChat,
    selectedTenantId,
    onSendMessage,
  } = useInfiniteMessages();

  const users = useMemo(() => {
    return getChatMembers(selectedChat);
  }, [selectedChat]);

  useEffect(() => {
    if (!isShowTicketInfo && scrollContainerRef?.current) {
      scrollContainerRef.current.scrollTop =
        scrollContainerRef?.current?.scrollHeight;
    }
  }, [isShowTicketInfo]);

  return (
    <StyledChatView xs={24} md={11} className="chat-view">
      {isShowTicketInfo ? (
        <TicketInfo
          selectedChat={selectedChat}
          setIsShowTicketInfo={setIsShowTicketInfo}
          user={user}
        />
      ) : (
        <div className="right-panel slide-in-left">
          {selectedChat ? (
            <>
              <div className="chat-header flex justify-space-between align-center">
                <div className="header-left flex align-center">
                  <Button
                    type="text"
                    shape="circle"
                    icon={<LeftOutlined />}
                    className="back-button"
                    onClick={() => {
                      dispatch(
                        setKeyValue({
                          key: "selectedChatId",
                          value: null,
                        }),
                      );
                    }}
                  />
                  <Avatar
                    size={34}
                    className="avatar"
                    user={selectedChat.assigned_advisor}
                  />
                  <div className="customer-info ellipsis-text">
                    {selectedChat?.name ||
                      getFullName(selectedChat.assigned_advisor)}
                    &nbsp;(#
                    {selectedChat.display_id})
                  </div>
                </div>
                <div className="header-actions">
                  <Button
                    type="text"
                    icon={<InfoCircleOutlined />}
                    className="action-btn"
                    title="Ticket Info"
                    onClick={() => {
                      setIsShowTicketInfo(!isShowTicketInfo);
                    }}
                  />
                </div>
              </div>

              <div className="messages-area" ref={scrollContainerRef}>
                <div ref={observerTarget} />

                {isLoading && <Spin />}
                {selectedChat?.messages?.map((msg, i) => (
                  <MessageItem
                    key={i}
                    message={msg}
                    isCurrentUser={user?.user_id === msg.sender_id}
                    users={users}
                  />
                ))}
              </div>

              <ChatInput
                onSendMessage={onSendMessage}
                selectedChat={selectedChat}
                selectedTenantId={selectedTenantId}
              />
            </>
          ) : (
            <div className="flex justify-center h-100 w-100 align-center">
              <Empty description="Select a conversation" image={LogoImage} />
            </div>
          )}
        </div>
      )}
    </StyledChatView>
  );
};

export default ChatView;
